import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Popconfirm, Space } from 'antd';
import { Table, Button } from 'ui/styled';
import { DeleteOutlined } from '@ant-design/icons';
import { useContainerDimensions, getSecureTableHeight } from 'utils/hooks/useContainerDimensions';
import useUsersTable from './hooks/useUsersTable';
var OFFSET = 140;
var columns = function (onUserDelete) {
    return [
        {
            title: 'Name',
            key: 'name',
            dataIndex: 'name',
            render: function (_, item) { return "".concat(item === null || item === void 0 ? void 0 : item.first_name, " ").concat(item === null || item === void 0 ? void 0 : item.last_name); },
            width: '40%'
        },
        {
            title: 'Teams',
            key: 'teams',
            dataIndex: 'teams',
            render: function (_, item) { var _a, _b; return (_b = (_a = item === null || item === void 0 ? void 0 : item.teams) === null || _a === void 0 ? void 0 : _a.map(function (team) { return team.name; }).join(', ')) !== null && _b !== void 0 ? _b : 'N/A'; },
            width: '40%'
        },
        {
            title: 'Actions',
            key: 'actions',
            render: function (_, item) {
                return (_jsx(Space.Compact, { children: _jsx(Popconfirm, { title: "Are you sure you want to delete this user?", onConfirm: function () { return onUserDelete(item === null || item === void 0 ? void 0 : item.id); }, children: _jsx(Button, { icon: _jsx(DeleteOutlined, {}) }) }) }));
            },
            width: '20%'
        }
    ];
};
export var UsersTable = function (_a) {
    var id = _a.id, filterValues = _a.filterValues, onUserDelete = _a.onUserDelete, containerRef = _a.containerRef;
    var data = useUsersTable({ filterValues: filterValues, id: id, containerRef: containerRef }).data;
    var loading = data.loading, users = data.users, scrollLoading = data.scrollLoading;
    var dimensions = useContainerDimensions(containerRef).dimensions;
    return (_jsx(Table, { mixCellTestId: true, filterValues: filterValues, columns: columns(onUserDelete), loading: loading || scrollLoading, scroll: {
            y: getSecureTableHeight(dimensions.height - OFFSET)
        }, tableLayout: "fixed", dataSource: users }, dimensions === null || dimensions === void 0 ? void 0 : dimensions.width));
};
